module.exports = __webpack_public_path__ + "img/default.9c53897d.png";